if (!customElements.get('restivo-mask-gift')) {
    customElements.define('restivo-mask-gift', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.quantity = this.closest('quantity-breaks');
        this.radio = document.getElementById(this.dataset.radioId);
        this.select = this.querySelector('select');
        this.options = this.querySelector('fieldset');
        this.photo = this.querySelector('img');
        if (!this.form || !this.quantity || !this.radio || !this.select) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.quantity.addEventListener('change', () => this.update(), options);
        this.form.addEventListener('submit', () => this.prepareGift(), { ...options, capture: true });
        this.form.addEventListener('click', (event) => {
          if (event.target.closest('button[name="add"], button[type="submit"]')) this.prepareGift();
        }, { ...options, capture: true });
        this.dataset.giftReady = 'true';
        this.update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.stopChoosing();
      }
      update() {
        const selected = this.radio.checked;
        this.options.hidden = !selected;
        this.options.disabled = !selected;
        const option = this.select.selectedOptions[0];
        if (this.photo && option?.dataset.image) {
          this.photo.removeAttribute('srcset');
          this.photo.src = option.dataset.image;
        }
      }
      stopChoosing() {
        clearInterval(this.giftInterval);
        clearTimeout(this.giftTimeout);
      }
      prepareGift() {
        this.stopChoosing();
        const selected = this.select.selectedOptions[0];
        if (!this.radio.checked || !selected || selected.disabled) return;
        this.pendingVariant = selected.value;
        this.dataset.pendingVariant = selected.value;
        this.giftInterval = setInterval(() => this.chooseGift(), 250);
        this.giftTimeout = setTimeout(() => this.stopChoosing(), 60000);
      }
      chooseGift() {
        const selector = `.bogos-gift-item-add-btn[data-product="${CSS.escape(this.dataset.giftProductId)}"][data-variant="${CSS.escape(this.pendingVariant)}"][data-available="true"]`;
        const button = document.querySelector(selector);
        const dialog = button?.closest('[role="dialog"]');
        if (!button || button.disabled || !dialog || !button.getClientRects().length || getComputedStyle(dialog).visibility === 'hidden') return;
        this.stopChoosing();
        this.dataset.giftSelected = this.pendingVariant;
        button.click();
      }
    });
  }
